/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import moment from 'moment';

// Misc imports
import { DEFAULT_DATE_FORMAT } from '../../../constants/main';

/**
 *
 *
 * @export
 * @param {Array} data //Array to be iterated and formatted // Data structure should be like this [{date: '2018-01-01', count: 100, type: string (if it exists)}, {date: '2018-01-02', count: 200, type: string (if it exists)}]
 * @return {Array} // Returns an array of objects with the format {x: Date, y: Number} and {x: Date, y: Number, type: string || null} if required
 */

export const formatChartData = (data) => {
  if (data) {
    let chart = [];
    for (const point of data) {
      chart.push({
        x: moment(point.string_date).format(DEFAULT_DATE_FORMAT),
        y: point.count,
        type: point.type || null
      });
    }

    return chart;
  } else {
    return [];
  }
};
